module.exports = __webpack_public_path__ + "img/certificate-4.0b263cb2.png";